import * as R from "ramda";
import {getStaticContent} from "static-content/view/api";

export function fetchBlock(blockName) {
    console.log(`Fetch block: '${blockName}'`);
    if (window.GLOBAL_BLOCK) {
        if (blockName !== window.GLOBAL_BLOCK.blockName) return null;
        return window.GLOBAL_BLOCK;
    }
    return R.find(block => block.blockName === blockName, getStaticContent().blocks);
}

export function prefetchGifsAndImages(block, MEDIA_URL) {
    if (block.gifs != null) {
        block.gifs.forEach(
            gif => (new Image().src = `${MEDIA_URL}/${gif.hash}.${gif.extension}`)
        );
    }
}

/**
 * Some buttons might carry extra information to be sent to the analytics system. This must always be logged respecting
 * the interface of tagName and tagValue, however, the source of these two parameters can vary. In the dbot editor it is possible
 * to define an special behavior tag and a logger tag. Regarding the analytics, if the logger tag is defined, this is the one
 * which is going to be sent. If there is no logger tag defined, but there is an special behavior tag defined, this one is going to be logged.
 * Therefore, logger tag has precedence over special behavior tag. This allows the person designing the dbot conversations to avoid
 * defining special behavior tags and logger tags which contain the same information. However, if the need exists to log something different
 * the logger tag will override the special behavior tag.
 * @param button
 * @returns {{tagValue: *, tagName: *}|{}}
 */
export const getLoggerTag = (button) => {
    if (!button.logger || !button.logger.code) {
        if (!button.tag || !button.tag.code) return {};
        else return {tagName: button.tag.code, tagValue: button.tag.value}
    }
    return {tagName: button.logger.code, tagValue: button.logger.value};
};
export const buildLog = (button) => {
    const loggerArray = button.logger ? button.logger : []
    const loggerArrayWithExtraValue = button.extraValueLog ? [...loggerArray, button.extraValueLog] : loggerArray
    return {
        eventName: "clickChatbot",
        elemId: `${button.blockName}@${button.id}`,
        category: "dbot",
        loggerArray: loggerArrayWithExtraValue
    }
};